import PillContainer from '../../../../core-system/Pill/Pill'
import React from 'react'
import styled from 'styled-components'
import { SegmentListType } from '../types'
import Tooltip from '@mui/material/Tooltip'

const SegmentsContainer = styled.div<{ isDrawer?: boolean }>`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.5rem;
  max-width: 40rem;
  flex-wrap: ${(props) => (props.isDrawer ? 'wrap' : 'nowrap')};
`

const SegmentsDisplay = ({
  segments,
  displayType = 'table',
}: {
  segments: SegmentListType[]
  displayType: 'table' | 'drawer'
}) => {
  const segmentsLength = segments ? segments.length : 0

  if (segmentsLength === 0) {
    return null
  }

  if (displayType === 'table') {
    if (segmentsLength > 1) {
      return (
        <Tooltip title={segments.map((segment) => segment.text).join(', ')}>
          <SegmentsContainer>
            <PillContainer>{segments[0].text}</PillContainer>
            <PillContainer>+ {segmentsLength - 1} more</PillContainer>
          </SegmentsContainer>
        </Tooltip>
      )
    } else {
      return segments.map((segment: SegmentListType) => (
        <PillContainer key={segment.id}>{segment.text}</PillContainer>
      ))
    }
  }

  if (displayType === 'drawer') {
    return (
      <SegmentsContainer isDrawer={true}>
        {segments.map((segment: SegmentListType) => (
          <PillContainer key={segment.id} showFullText={true}>
            {segment.text}
          </PillContainer>
        ))}
      </SegmentsContainer>
    )
  }

  return null
}

export default React.memo(SegmentsDisplay)
